import { languageDutch } from "../i18n";

export function getCurrentLang(
  storyblokLang: string | null,
  language?: string
) {
  // In Storyblok, "default" means the default language of the project, which is Dutch in our case
  if (storyblokLang === "default") {
    return languageDutch;
  }

  return storyblokLang ?? language ?? languageDutch;
}
